import Vue from "vue";
import Router from "vue-router";
// import BroadcastFlow from "@/components/BroadcastFlow";
const AbnormalMsg = () => import('./views/AbnormalMsg') // 异常提醒开关
const EquipmentList = () => import('./views/EquipmentList') // 应用监控
const ApplicationList = () => import('./views/applicationList') // 应用列表
Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "signin",
            component: () => import("./views/SignIn") // 登录
        },

        {
            path: "/signup",
            name: "signup",
            component: () => import("./views/SignUp") // 注册
        },

        {
            path: "/forgotpassword",
            name: "forgotpassword",
            component: () => import("./views/ForgotPassword") // 忘记密码
        },

        {
            path: "/bindPhoneNumber",
            name: "bindPhoneNumber",
            component: () => import("./views/BindPhoneNumber") // 绑定手机号
        },
        {
            path: "/bindUser",
            name: "bindUser",
            component: () => import("./views/BindUser") // 绑定账号 create by wyq
        },
        {
            path: "/unbindUser",
            name: "unbindUser",
            component: () => import("./views/UnBindUser") // 解绑账号 create by wyq
        },
        {
            path: "/home",
            name: "home",
            component: () => import("./views/Home") // 首页
        },

        {
            path: "/devicePlay",
            name: "devicePlay",
            component: () => import("./views/DevicePlay") // 播流
        },

        {
            path: "/order",
            name: "order",
            component: () => import("./views/OrderCenter") // 订单中心
        },

        {
            path: "/message",
            name: "message",
            component: () => import("./views/MessageCenter") // 消息中心
        },

        {
            path: "/result",
            name: "result",
            component: () => import("./views/Result") // 支付结果
        },

        {
            path: "/package",
            name: "package",
            component: () => import("./views/Package") // 套餐购买
        },

        {
            path: "/customer",
            name: "customer",
            component: () => import("./views/Customer") // 在线客服
        },

        {
            path: "/confirmOrder",
            name: "confirmOrder",
            component: () => import("./views/ConfirmOrder") // 确认订单
        },

        {
            path: "/activity",
            name: "Activity",
            component: () => import("./views/Activity")
        },

        {
            path: '/abnormalMsg', //异常消息提醒
            name: 'AbnormalMsg',
            component: AbnormalMsg
        },
        {
            path: '/equipmentList',
            name: 'EquipmentList',
            component: EquipmentList
        },
        {
            path: '/applicationList',
            name: 'ApplicationList',
            component: ApplicationList
        },
        {
            path: "/404",
            name: "404",
            component: () => import("./views/404")
        },

        {
            path: "/share",
            name: "share",
            component: () => import("./views/share")
        },
        {
            path: "/welfare",
            name: "welfare",
            component: () => import("./views/NoviceWelfare")
        },

    ]
});
